import { render } from "./SmoothScrollLink.vue?vue&type=template&id=1154bd2f"
import script from "./SmoothScrollLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SmoothScrollLink.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/SmoothScrollLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1154bd2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1154bd2f', __exports__)) {
    console.log('reload')
    api.reload('1154bd2f', __exports__)
  }
  
  module.hot.accept("./SmoothScrollLink.vue?vue&type=template&id=1154bd2f", () => {
    console.log('re-render')
    api.rerender('1154bd2f', render)
  })

}


export default __exports__